import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import HomePage from '../Screens/HomePage'
import Header from '../Components/Header/Header'
import Layout from '../Components/Layout/Layout'
import AboutUs from '../Screens/AboutUs'
import Clients from '../Screens/Clients'
import ClientDetails from '../Screens/ClientDetails'
import ServicesPage from '../Screens/ServicesPage'
import ContactPage from '../Screens/ContactPage'
import PrivacyPolicy from '../Screens/PrivacyPolicy'
import DevelopmentPractices from '../Screens/DevelopmentPractices'
import DetailServicePage from '../Screens/DetailServicePage'
import CaseStudies from '../Screens/CaseStudies'
import MMCaseStudies from '../Screens/CaseStudiedDetails/MMCaseStudies'
import WolfpackCaseStudies from '../Screens/CaseStudiedDetails/WolfpackCaseStudies'
import WefrothCaseStudies from '../Screens/CaseStudiedDetails/WefrothCaseStudies'
import NotFoundPage from '../Components/NotFound/NotFound'

function AppRoutes() {
  return (
    <Routes>
      <Route path='/' element={
        <Layout>
          <HomePage />
        </Layout>
      }></Route>
      <Route path='/about' element={
        <Layout>
          <AboutUs />
        </Layout>
      }></Route>
      <Route path='/clients' element={
        <Layout>
          <Clients />
        </Layout>
      }></Route>
      <Route path='/client-details/:client' element={
        <Layout>
          <ClientDetails />
        </Layout>
      } />
      <Route path='/services' element={
        <Layout>
          <ServicesPage />
        </Layout>
      } />
      <Route
        path="/services/:serviceSlug"
        element={
          <Layout>
            <DetailServicePage />
          </Layout>
        }
      />
      {/* <Route path='/service-details' element={
        <Layout>
          <DetailServicePage />
        </Layout>
      } /> */}
      <Route path='/contact' element={
        <Layout>
          <ContactPage />
        </Layout>
      } />
      <Route path='/case-studies' element={
        <Layout>
          <CaseStudies />
        </Layout>
      } />
      <Route path='/case-studies/mystery-management' element={
        <Layout>
          <MMCaseStudies />
        </Layout>
      } />
      <Route path='/case-studies/wolfpack' element={
        <Layout>
          <WolfpackCaseStudies />
        </Layout>
      } />
      <Route path='/case-studies/wefroth' element={
        <Layout>
          <WefrothCaseStudies />
        </Layout>
      } />
      <Route path='/privacy-policy' element={
        <Layout>
          <PrivacyPolicy />
        </Layout>
      } />
      <Route path='/development-practices' element={
        <Layout>
          <DevelopmentPractices />
        </Layout>
      } />

      <Route
        path="/services/crm-custom-software"
        element={<Navigate to="/services/custom-software-development-services" replace />}
      />
      <Route
        path="/services/mobile-app-iot"
        element={<Navigate to="/services/mobile-app-development-services" replace />}
      />
      <Route
        path="/services/ai-machine-learning"
        element={<Navigate to="/services/ai-automation-and-machine-learning-services" replace />}
      />
      <Route
        path="/services/seo"
        element={<Navigate to="/services/seo-services" replace />}
      />
      <Route
        path="/services/social-media-marketing"
        element={<Navigate to="/services/social-media-marketing-services" replace />}
      />
      <Route path="/404" element={<NotFoundPage />} />

      {/* Redirect unknown URLs */}
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  )
}

export default AppRoutes
